module.exports = __webpack_public_path__ + "app-static/img/17.bb2e215d.png";